import { makeStyles,theme } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme =>({
  root: {
    padding: '6px 0',
    fontSize: '13px',
    lineHeight: '18px',
    color: '#59758B',
    '&:hover': {
      backgroundColor: 'white',
     [theme.breakpoints.down('sm')]:{
      alignItems: 'center',
     }
    }
  },
  startIcon: {
    fontSize: '19px',
    color: '#59758B'
  }
}));
